export default "__VITE_ASSET__1b1653fc__"